<template>
  <div class="oip-publication-list">
    <publication-entry v-for="publication in publications"
                       :publication="publication"
                       :key="publication.id"></publication-entry>
    <div v-if="showLoadMore" class="load-more">
      <i @click="getPublications()" class="icon-pictos_site_OIP_plus"></i>
      <span v-if="isLoading">chargement...</span>
    </div>
  </div>
</template>

<script>
  import PublicationEntry from './PublicationEntry.vue'
  import _ from 'lodash'

  export default {

    props: {
      publicationsType: String
    },

    components: {
      PublicationEntry
    },

    data () {
      return {
        publications: [],
        perPage: 0,
        currentPage: 1,
        wpTotal: 0,
        isLoading: false
      }
    },

    computed: {

      showLoadMore () {
        return this.publications.length < this.wpTotal
      }

    },

    methods: {

      getPublications () {
        this.isLoading = true
        let offset = this.publications.length
        this.$http.get(apiUrl + 'wp/v2/publications?_embed=featuredmedia&per_page=' + this.perPage + '&offset=' + offset + '&filter[meta_key]=publication_type_de_la_publication&filter[meta_value]=' + this.publicationsType)
            .then(response => {
              this.isLoading = false
              this.wpTotal = response.headers.get('X-Wp-Total')
              _.forEach(response.body, item => {
                this.publications.push(item)
              })
            })
            .catch(response => {
              this.isLoading = false
              console.log(response)
            })
      }

    },

    mounted () {
      this.perPage = window.initialState.perPage
      this.publications = window.initialState.publications
      this.wpTotal = window.initialState.wpTotal
    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/publications/PublicationList.vue